export const retry = async <T>(
  options: {
    /**
     * Retry up to this many times, including initial attempt.
     */
    maxAttempts: number;

    /**
     * Wait this many milliseconds between failed attempt and next attempt.
     */
    delayBetweenAttempts: number;
  },

  /**
   * Function to attempt.
   */
  callback: (attempt: number) => Promise<T>,

  /**
   * Optional listener for caught error of a failed attempt, e.g. for logging.
   */
  onError?: (error: unknown) => void,
): Promise<T> => {
  const { maxAttempts, delayBetweenAttempts } = options;

  // eslint-disable-next-line @typescript-eslint/init-declarations
  let finalError;
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      if (attempt > 1) {
        // eslint-disable-next-line no-await-in-loop
        await new Promise((resolve) =>
          setTimeout(resolve, delayBetweenAttempts),
        );
      }

      // eslint-disable-next-line no-await-in-loop
      return await callback(attempt);
    } catch (error) {
      finalError = error;

      onError?.(error);
    }
  }
  throw finalError;
};
